import { AxiosInstance } from 'axios'
import { Dayjs } from 'dayjs'
import { CoordinateType } from '@/api/types/general/GeneralType'
import { WeatherType } from '@/utilities/weather/types/WeatherType'
import WeatherServiceInterface from '@/utilities/weather/services/interfaces/WeatherServiceInterface'

export default abstract class WeatherServiceAbstract implements WeatherServiceInterface {
  protected readonly apiKey: string
  protected readonly httpClient: AxiosInstance

  constructor(apiKey: string, httpClient: AxiosInstance) {
    this.apiKey = apiKey
    this.httpClient = httpClient
  }

  abstract getInfo(coordinate: CoordinateType, date: Dayjs): Promise<WeatherType>
}
